exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attach-workflow-detail .drawercontainer {\n  padding: 1rem;\n}\n.attach-workflow-detail .drawercontainer-button {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  border-top: 1px solid #e9e9e9;\n  padding: 10px 16px;\n  background: #fff;\n  text-align: left;\n  z-index: 10;\n}\n.attach-workflow-detail .ant-drawer-right .ant-drawer-content-wrapper {\n  width: 50% !important;\n  padding: 15px;\n  background: #ffffff;\n}\n.photocard {\n  background-color: white !important;\n}\n", ""]);

// exports
